import AdConsole from './Adconsole';
import Facebook from './Facebook';
import Google from './Google';
import Linkedin from './Linkedin';
import Meta from './Meta';
import Microsoft from './Microsoft';
import Passendo from './Passendo';
import Semantiq from './Semantiq';
import Xandr from './Xandr';
import Yaleo from './Yaleo';
export const BrandIcons = {
    AdConsole,
    Facebook,
    Google,
    Linkedin,
    Meta,
    Microsoft,
    Passendo,
    Semantiq,
    Xandr,
    Yaleo,
};
export default BrandIcons;
